document.addEventListener('DOMContentLoaded', (): void => {
  const modal: HTMLElement | null = document.getElementById('media-modal');
  const modalBody: HTMLElement | null = modal ? modal.querySelector('.media-modal-body') : null;
  const modalTitle: HTMLElement | null = modal ? modal.querySelector('.media-modal-title') : null;
  const closeBtn: HTMLElement | null = modal ? modal.querySelector('.media-modal-close') : null;
  const mediaContainers: NodeListOf<HTMLElement> = document.querySelectorAll('.project-media-container');

  if (!modal || !modalBody || !modalTitle || !closeBtn) {
    return;
  }

  const isYouTubeUrl = (url: string): boolean => {
    return url.includes('youtube.com') || url.includes('youtu.be');
  };

  const getYouTubeEmbedUrl = (url: string): string => {
    if (url.includes('youtube.com/embed/')) return url;
    try {
      if (url.includes('youtube.com/watch')) {
        const parts = url.split('?')[1];
        const params = new URLSearchParams(parts);
        const v = params.get('v');
        if (v) return `https://www.youtube.com/embed/${v}`;
      } else if (url.includes('youtu.be/')) {
        const id = url.split('youtu.be/')[1]?.split('?')[0];
        if (id) return `https://www.youtube.com/embed/${id}`;
      }
    } catch (e) {
      // Fallback
    }
    return url;
  };

  const openModal = (videoUrl: string, imageUrl: string, title: string): void => {
    modalBody.innerHTML = '';
    modalBody.className = 'media-modal-body';
    modalTitle.textContent = title;

    if (videoUrl) {
      if (isYouTubeUrl(videoUrl)) {
        const iframe: HTMLIFrameElement = document.createElement('iframe');
        iframe.src = `${getYouTubeEmbedUrl(videoUrl)}?autoplay=1`;
        iframe.className = 'video-iframe';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', 'true');
        modalBody.appendChild(iframe);
      } else {
        const video: HTMLVideoElement = document.createElement('video');
        video.src = videoUrl;
        video.className = 'video-player';
        video.controls = true;
        video.autoplay = true;
        modalBody.appendChild(video);
      }
    } else if (imageUrl) {
      modalBody.classList.add('image-view');
      const img: HTMLImageElement = document.createElement('img');
      img.src = imageUrl;
      img.alt = title;
      modalBody.appendChild(img);
    } else {
      return;
    }

    modal.classList.add('active');
    document.body.classList.add('modal-open');
  };

  const closeModal = (): void => {
    modal.classList.remove('active');
    document.body.classList.remove('modal-open');
    modalBody.innerHTML = '';
    modalTitle.textContent = '';
  };

  mediaContainers.forEach((container: HTMLElement): void => {
    container.addEventListener('click', (): void => {
      const videoUrl: string = container.getAttribute('data-video-url') || '';
      const imageUrl: string = container.getAttribute('data-image-url') || '';
      const title: string = container.getAttribute('data-project-title') || '';
      openModal(videoUrl, imageUrl, title);
    });
  });

  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', (e: MouseEvent): void => {
    if (e.target === modal) {
      closeModal();
    }
  });

  window.addEventListener('keydown', (e: KeyboardEvent): void => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
});
